import _ from 'lodash';
import type { Brief } from '@fiverr-private/ai_brief';
import type { Range } from '../../types/range';

interface BudgetSectionContent {
    budgetInCents?: number;
    hourlyBudgetRange?: Range<number>;
}

export const getMaxBudgetInCentsFromBrief = (brief?: Brief): number | null => {
    if (!brief?.sections?.length) return null;

    const budgetSection = brief.sections.find((s) => s.id === 'budget' || s.id === 'budget_and_timeline');
    const content = budgetSection?.content as BudgetSectionContent | undefined;

    if (!content) return null;

    const { budgetInCents, hourlyBudgetRange } = content;
    const maxCents = hourlyBudgetRange?.max ?? budgetInCents;

    return !_.isNil(maxCents) && maxCents > 0 ? maxCents : null;
};
